<div>
  <img
    #articleImage
    (error)="articleImage.src = 'assets/icon/imageNotFound.svg'"
    src="https://azwestprodesdcdnapps.blob.core.windows.net/efpcont/Previews/{{
      articleId
    }}.jpg?sp=rl&st=2021-09-15T09:21:34Z&se=2025-01-01T18:21:34Z&spr=https&sv=2020-08-04&sr=c&sig=mZ%2By7AAFFsTnAm%2BJrMp9SZ7u1VqLUylAHC7hMHrq%2B5A%3D" />
</div>
